// extracted by mini-css-extract-plugin
module.exports = {"SenceCardD":"SenceCardD_SenceCardD__eFOxq"};